'use client';

import styled, { DefaultTheme } from 'styled-components';

import { Spacers } from '@styles/theme';

export const getLabelTypography = (props: { theme: DefaultTheme }) => `
  font-weight: ${props.theme.typography.label.fontWeight};
  line-height: ${props.theme.typography.label.lineHeight};
  font-size: ${props.theme.typography.label.fontSize};
  color: ${props.theme.colors.typographyBodyLight};
`;

export const Label = styled.label`
  ${getLabelTypography}
  display: inline-block;
  margin-bottom: ${Spacers.XS}rem;
  color: ${({ theme }) => theme.colors.typographyBodyLight};
`;
